import groq from 'groq';

/* WARN: If you change this query, make sure to update MAX_POSSIBLE_SCORES */
export const searchSkincareScience = () => groq`
  *[
    _type == "timeline_skincareScience" &&
    !(_id in path("drafts.**"))
  ] | score(
      boost(_id match $searchTerm, 3),
      boost("Mitochondrial revitalization through our patented postBiotic™" match $searchTerm, 2),
      boost("Energized Skin is Healthy Skin" match $searchTerm, 2),
      references(*[_type == "timeline_benefits" && benefitModals[].title match $searchTerm]._id),
      references(*[_type == "timeline_benefits" && pt::text(benefitModals[].description[]) match $searchTerm]._id)
    ) {
      _type,
      _score
    }[ _score > 0 ]
`;
